import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Realmente puedo hacerlo si no soy creativo?',
  a: "Absolutamente. El método es 'pintar por números' pero en 3D. Si puedes seguir una línea, puedes hacer esto."
}, {
  q: '¿Qué materiales necesito?',
  a: 'Solo cartulina común de papelería, una regla, pegamento y un bolígrafo sin tinta. El 99% de nuestros alumnos ya tienen todo en casa.'
}, {
  q: '¿Tengo que imprimir en color?',
  a: 'No. Los diseños están optimizados para blanco y negro. El color lo da la cartulina que elijas comprar.'
}, {
  q: '¿Cómo recibo el producto?',
  a: 'Es 100% digital. Recibirás un email con acceso inmediato a nuestra plataforma apenas completes el pago.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 sm:py-24 px-4 bg-surface border-y border-white/5" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <div className="text-center mb-12" data-id="element-55">
          <h2 className="font-serif text-3xl sm:text-4xl text-text mb-4" data-id="element-56">
            Preguntas Frecuentes
          </h2>
          <p className="text-textMuted" data-id="element-57">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-white/10 rounded-xl overflow-hidden bg-background" data-id="element-59">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-60">
                <span className="font-medium text-text pr-4" data-id="element-61">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-accent flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" />
              </button>
              <AnimatePresence data-id="element-63">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-64">
                    <div className="px-6 pb-6 text-textMuted border-t border-white/5 pt-4" data-id="element-65">
                      <span className="text-accent mr-2" data-id="element-66">✅</span>
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}